import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-request',
  templateUrl: './customer-request.component.html',
  styleUrls: ['./customer-request.component.css']
})
export class CustomerRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
